import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'src/environments/environment';
import { BorderouService } from './borderou.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { helper } from 'src/environments/helper';
import { Subject } from 'rxjs';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AddBorderouComponent } from './add-borderou/add-borderou.component';

@Component({
    selector: 'app-borderou',
    templateUrl: './borderou.component.html',
    styleUrls: ['./borderou.component.scss']
})
export class BorderouComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    helper = helper;
    isLoading = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = environment.interop.basePath + environment.interop.platform.nomenclatoare.documenteCetatean.getBorderouDT;

    constructor(
        private http: HttpClient,
        private borderouService: BorderouService,
        private appFilesService: AppFilesService,
        private dialog: MatDialog,
        private breakpointObserver: BreakpointObserver,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            order: [[0, 'desc']],
            serverSide: true,
            searching: false,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Creator',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        return `
                            <div class="d-flex flex-column">
                                <span class="d-flex align-items-center gap-1"><img src="/assets/icons/icon-user.svg" alt="Image" style="width: 20px; height: 20px;">${row.user_name}</span>
                                <span>${this.formatRomanianDate(row.created_at)}</span>
                            </div>
                        `;
                    }
                },
                {
                    title: 'Nr. de documente',
                    data: 'number_of_documents',
                },
                {
                    title: 'Nr. de zile',
                    data: 'number_of_days',
                },
                {
                    title: 'Observații',
                    data: 'observations',
                    orderable: false,
                    render: (data: any) => {
                        if (data === null) {
                            return 'N/A'
                        } else {
                            return data
                        }
                    }
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
                            <div class="d-flex align-center justify-content-left">
                                <button style="color: white;" class="action-btn signatures ms-1 d-flex gap-1" title="Descarcă PDF">
                                    <i class="fa-solid fa-cloud-arrow-down" style="color: #fff;"></i>PDF
                                </button>
                                <button style="color: white;" class="action-btn action-success ms-1 d-flex gap-1" title="Descarcă CSV">
                                   <i class="fa-solid fa-cloud-arrow-down" style="color: #fff;"></i>CSV
                                </button>
                            </div>
                        `;
                    }
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const downloadPdfButton = lastTd?.querySelector('.signatures') as HTMLElement;
                const downloadCsvButton = lastTd?.querySelector('.action-success') as HTMLElement;

                if (downloadPdfButton) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.solicitari.citizen-documents.update'
                    //     )
                    // ) {
                    //     downloadPdfButton.style.display = 'none';
                    // }
                    downloadPdfButton.addEventListener('click', () => {
                        this.downloadBorderou(data.id, 1);
                    });
                }

                if (downloadCsvButton) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'auth-module.solicitari.citizen-documents.update'
                    //     )
                    // ) {
                    //     downloadCsvButton.style.display = 'none';
                    // }
                    downloadCsvButton.addEventListener('click', () => {
                        this.downloadBorderou(data.id, 2);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    formatRomanianDate(dateTimeString: string): string {
        const [datePart, timePart] = dateTimeString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}.${month}.${year} ${timePart}`;
    }

    downloadBorderou(id: number, type: number) { // type == 1 => pdf, type == 2 => csv
        let fullPath;
        if (type == 1) {
            fullPath = this.borderouService.downloadPdfUrl + id;
        } else {
            fullPath = this.borderouService.downloadCsvUrl + id;
        }
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    openAddDialog() {
        let configData = {
            width: '80%',
            height: 'auto',
            minWidth: '275px',
            autoFocus: false,
        };

        const dialogRef = this.dialog.open(AddBorderouComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 899px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', 'auto')
                } else {
                    // Larger devices
                    dialogRef.updateSize('90%', 'auto')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }
}
